import config from '@/const/config';
import { easyPost } from './utils';

// 不同活动 入参method 不同做区分
export const getRedbag = easyPost('moon.event.dispatch', {
  api: config.MARKET_API,
});

// 查询活动的组件列表信息
export const getActivityCode = easyPost('moon.activity.dispatch', {
  api: config.MARKET_API,
});

// 事件上送
export const eventUpload = easyPost('user.platform.event.upload');

// 生成微信公众号二维码
export const generate = easyPost('platform.wx.qrcode.generate');

// 获取配置信息
export const getLotteryConfig = easyPost('user.lottery.config');
// 签到
export const signBag = easyPost('moon.activity.dispatch', {
  api: config.MARKET_API,
});
// 查询开奖汇总视图
export const lotteryDetail = easyPost('user.lottery.detail');
// 查询用户最新期彩票号码列表接口
export const queryUserOrders = easyPost('sportsLottery.queryUserOrders', {
  api: config.MARKET_API,
});
// 生产二维码
export const getWechatCode = easyPost('platform.wx.qrcode.generate');


export const getLastLotteryResult = easyPost('user.lottery.detail');

// 跳转完成任务
export const jumpEvent = easyPost('mars.task.jumpEvent', {
  api: config.MARKET_API,
});
